import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const SocialWhatsapp = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="social-whatsapp"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      className={className}
      viewBox="-1 -1 27 27"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5031 0H12.4969C5.60469 0 0 5.60625 0 12.5C0 15.2344 0.88125 17.7687 2.37969 19.8266L0.821875 24.4703L5.62656 22.9344C7.60313 24.2438 9.96094 25 12.5031 25C19.3953 25 25 19.3922 25 12.5C25 5.60781 19.3953 0 12.5031 0ZM19.7766 17.6516C19.475 18.5031 18.2781 19.2094 17.3234 19.4156C16.6703 19.5547 15.8172 19.6656 12.9453 18.475C9.27187 16.9531 6.90625 13.2203 6.72188 12.9781C6.54531 12.7359 5.2375 11.0016 5.2375 9.20781C5.2375 7.41406 6.14844 6.54063 6.51562 6.16563C6.81719 5.85781 7.31562 5.71719 7.79375 5.71719C7.94844 5.71719 8.0875 5.725 8.2125 5.73125C8.57969 5.74687 8.76406 5.76875 9.00625 6.34844C9.30781 7.075 10.0422 8.86875 10.1297 9.05313C10.2188 9.2375 10.3078 9.4875 10.1828 9.72969C10.0656 9.97969 9.9625 10.0906 9.77812 10.3031C9.59375 10.5156 9.41875 10.6781 9.23438 10.9062C9.06563 11.1047 8.875 11.3172 9.0875 11.6844C9.3 12.0437 10.0344 13.2422 11.1156 14.2047C12.5109 15.4469 13.6422 15.8438 14.0469 16.0125C14.3484 16.1375 14.7078 16.1078 14.9281 15.8734C15.2078 15.5719 15.5531 15.0719 15.9047 14.5797C16.1547 14.2266 16.4703 14.1828 16.8016 14.3078C17.1391 14.425 18.925 15.3078 19.2922 15.4906C19.6594 15.675 19.9016 15.7625 19.9906 15.9172C20.0781 16.0719 20.0781 16.7984 19.7766 17.6516Z"
      />
    </svg>
  );
};
/* eslint-enable max-len */

SocialWhatsapp.defaultProps = {
  className: null,
};

SocialWhatsapp.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default SocialWhatsapp;
